<template>
  <div
    v-bind="$attrs"
    :class="{ 'w-100': block }"
    class="d-inline-block inherit-font-size"
  >
    <a
      :href="href || 'javascript:;'"
      :target="href && '_blank'"
      :rel="href && 'noopener'"
      :class="{
        'justify-space-between': block,
        'so-link--disabled': disabled,
      }"
      class="inherit-font-size"
      :dataTestId="dataTestId"
      :aria-disabled="disabled"
      @click.stop="!href && $emit('click')"
      >{{ text }}
      <div><slot></slot></div>
      <SoIcon v-if="icon" :icon="icon" class="ml-1" />
    </a>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoIcon from "./SoIcon.vue"
  import { IconStringWithModifiers } from "@/types/Icon"

  export default defineComponent({
    components: { SoIcon },
    inheritAttrs: false,
    props: {
      href: {
        type: String,
        default: null,
      },
      text: {
        type: String,
        default: "",
      },
      icon: {
        type: String as PropType<IconStringWithModifiers>,
        default: null,
      },
      block: {
        type: Boolean,
        default: false,
      },
      dataTestId: {
        type: String,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["click"],
  })
</script>

<style scoped>
  .inherit-font-size {
    font-size: inherit !important;
  }
  a {
    color: rgb(var(--v-theme-primary));
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  a:focus-visible {
    outline: var(--theme-outline);
    border-radius: var(--theme-radius);
  }
  .so-link--disabled {
    pointer-events: none;
    cursor: not-allowed;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    opacity: 0.26; /* matches vuetify */
  }
</style>
